document.addEventListener('DOMContentLoaded', () => {
  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;

  variantPicker.addEventListener('change', () => {
    setTimeout(() => {
      const gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      const firstItem = gallery.querySelector('li[ref="media[]"]');
      if (firstItem) {
        firstItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  });
});
